import ReactDOM from "react-dom/client";
import FlashcardApp from "./FlashcardApp";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(<FlashcardApp />);
